export enum UrlType {
	firebase = 'firebase',
}
